import { kontentAiDataMapping } from '@r-and-a-shared-ui/core-data-mapping';

import type { PLAYER_PORTALS_MODELS } from '@r-and-a-shared-ui/common-kontent-client';
import { PlayerPortalsGridPage } from '@r-and-a-shared-ui/common-ui';

export default {
  component: () => PlayerPortalsGridPage,
  mapEntryToProps: (entry: PLAYER_PORTALS_MODELS.GridPage) =>
    kontentAiDataMapping.player_portals_grid_page(entry),
};
